import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_44: FaireProductEntity = {
  token: "catalog_prod_prod-44",
  type: "product",
  name: "Black Mango Wood Milking Stool",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 102.99,
  msrpDollars: 257.47,
  sku: "JA0044",
  caseSize: 12,
  material: "Cotton",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 370,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-fragrances"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
